export default {"src":"/_next/static/media/blue-usd-rounded-white-border.f2c80267.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};